import React, { useState, useRef, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import { GoogleMap, LoadScript } from "@react-google-maps/api";
import LocationIcon from "./assets/Group 8796.png";
import { useLocation, useNavigate } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import SearchIcon from "./assets/Search_alt.png";
import ReCAPTCHA from "react-google-recaptcha";
const libraries = ["places", "marker"];

const Address = () => {
  const location = useLocation();
  useEffect(() => {
    console.log("location.state:", location.state);
  }, [location.state]);

  const { estimatedPrice, name } = location.state;

  const containerStyle = {
    width: "100%",
    height: "100%",
    borderRadius: "15px",
    overflow: "hidden",
  };

  const initialCenter = {
    lat: 25.276987,
    lng: 55.296249,
  };

  const [map, setMap] = useState(null);
  const [center, setCenter] = useState(initialCenter);
  const [marker, setMarker] = useState(null);
  const [address, setAddress] = useState("");
  const [apartment, setApartment] = useState("");
  const [additionalAddress, setAdditionalAddress] = useState("");
  const [fullName, setFullName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [isAddressSelected, setIsAddressSelected] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [mainAddressCountry, setMainAddressCountry] = useState("");
  const [additionalAddressCountry, setAdditionalAddressCountry] = useState("");
  const [geoFenceError, setGeoFenceError] = useState(""); // Add this state
  const searchBoxRef = useRef(null);
  const navigate = useNavigate();

  const handleLoad = async (mapInstance) => {
    console.log("Map loaded:", mapInstance);
    setMap(mapInstance);
  
    // Center the map on initial load
    mapInstance.setCenter(initialCenter);
    mapInstance.setZoom(5); // Set initial zoom level
  
    const input = document.getElementById("address-search");
    const autocomplete = new window.google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: "ae" }, // Restrict to UAE
    });
  
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (!place.geometry || !place.geometry.location) return;
  
      const newLocation = place.geometry.location;
      setCenter(newLocation);
      updateMarkerPosition(newLocation);
      setAddress(place.formatted_address);
  
      // Adjust zoom level and center the map on search
      mapInstance.setZoom(15);
      mapInstance.setCenter(newLocation);
    });
  
    // Add the initial marker and set map center if mapInstance is not null
    if (mapInstance) {
      try {
        await addMarker(mapInstance, initialCenter, 10); // Pass the zoom level here
        mapInstance.setCenter(initialCenter); // Ensure map is centered on initial load
      } catch (error) {
        console.error("Error adding marker:", error);
        toast.error("Error adding marker");
        
      }
    }
  };
  
  useEffect(() => {
    if (address.length > 0) setIsAddressSelected(true);
  }, [address]);

  const addMarker = async (mapInstance, position, zoomLevel = 10) => {
    const { AdvancedMarkerElement } = await window.google.maps.importLibrary(
      "marker"
    );
    const newMarker = new AdvancedMarkerElement({
      map: mapInstance,
      position: position,
      title: "Selected Location",
      draggable: true,
    });

    newMarker.addListener("dragend", async (event) => {
      const lat = event.latLng.lat();
      const lng = event.latLng.lng();
      const newPosition = { lat, lng };

      setCenter(newPosition);
      updateMarkerPosition(newPosition);

      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: newPosition }, (results, status) => {
        if (status === "OK" && results[0]) {
          setAddress(results[0].formatted_address);
          getCountryFromAddress(
            results[0].formatted_address,
            setMainAddressCountry
          );
        }
      });

      mapInstance.setZoom(15);
      mapInstance.setCenter(newPosition);
    });

    setMarker(newMarker);
    mapInstance.setZoom(zoomLevel);
  };

  const updateMarkerPosition = (position) => {
    if (marker) {
      marker.position = position;
    } else if (map) {
      addMarker(map, position);
    }
  };

  useEffect(() => {
    if (map) {
      const handleClick = (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        const newCenter = { lat, lng };

        setCenter(newCenter);
        updateMarkerPosition(newCenter);

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: newCenter }, (results, status) => {
          if (status === "OK" && results[0]) {
            setAddress(results[0].formatted_address);
            getCountryFromAddress(
              results[0].formatted_address,
              setMainAddressCountry
            );
          }
        });

        map.setZoom(15);
        map.setCenter(newCenter);
      };

      map.addListener("click", handleClick);

      return () => {
        window.google.maps.event.clearListeners(map, "click");
      };
    }
  }, [map, marker]);

  const getCountryFromAddress = (address, setCountry) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address }, (results, status) => {
      if (status === "OK" && results[0]) {
        const addressComponents = results[0].address_components;
        const countryComponent = addressComponents.find((component) =>
          component.types.includes("country")
        );
        if (countryComponent) {
          setCountry(countryComponent.long_name);
        }
      }
    });
  };

  const handleZoomIn = () => {
    if (map) {
      map.setZoom(map.getZoom() + 1);
    }
  };

  const handleZoomOut = () => {
    if (map) {
      map.setZoom(map.getZoom() - 1);
    }
  };

  const handleCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        setCenter(currentLocation);
        updateMarkerPosition(currentLocation);

        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: currentLocation }, (results, status) => {
          if (status === "OK" && results[0]) {
            setAddress(results[0].formatted_address);
            getCountryFromAddress(
              results[0].formatted_address,
              setMainAddressCountry
            );
          }
        });

        map.setZoom(15);
        map.setCenter(currentLocation);
      });
    }
  };

  const isValidMobileNumber = (number) => {
    return number.startsWith("9715") && number.length <= 12;
  };

  const handleCaptchaVerify = (value) => {
    if (value) {
      setCaptchaVerified(true);
      setCaptchaToken(value);
    }
  };

  const handleAdditionalAddressChange = (e) => {
    const value = e.target.value;
    setAdditionalAddress(value);
    if (value) {
      getCountryFromAddress(value, setAdditionalAddressCountry);
    }
  };

  // Update handleContinue to include the country check and warning message
  const handleContinue = (e) => {
    e.preventDefault();
    if (mainAddressCountry !== additionalAddressCountry) {
      setGeoFenceError(
        "The main address and additional address must be in the same country."
      );
      return;
    } else {
      setGeoFenceError(""); // Clear the error if countries match
    }
    navigate("/booking-confirmed", {
      state: {
        ...location.state,
        estimatedPrice,
        name,
        apartment,
        address,
        additionalAddress,
        fullName,
        mobileNumber,
      },
    });
  };

  const handleGoBack = () => {
    navigate("/booking-fee", { state: { ...location.state } });
  };
  return (
    <div className="container mx-auto ">
      <ToastContainer />
      <button
        onClick={handleGoBack}
        className="hidden w-28 h-9 px-4 mb-3 py-2 sm:flex items-center justify-center gap-2 bg-white border border-gray-300 rounded-md shadow-sm"
      >
        <span className="">
          <MdKeyboardArrowLeft />
        </span>
        <span className="font-bold font-plus-jakarta-sans text-[14px] leading-[20px]">
          Go Back
        </span>
      </button>
      <h1 className="font-bold sm:mt-6 font-plus-jakarta-sans text-4xl mb-4  xl:max-w-[400px]">
        Select your address
      </h1>
      <p className="text-lg font-plus-jakarta-sans text-[#475467] mb-8 xl:max-w-[330px]">
        Where should we come to collect the device?
      </p>
      <div className="flex flex-col lg:flex-row lg:space-x-8 space-y-8 lg:space-y-0">
        <div className="relative w-full lg:w-[400px] h-96 lg:h-[590px]">
          <LoadScript
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
            libraries={libraries}
            id="script-loader"
          >
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              zoom={10}
              onLoad={handleLoad}
              options={{
                fullscreenControl: false,
                zoomControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                mapId: process.env.REACT_APP_GOOGLE_MAPID_KEY,
              }}
            />
          </LoadScript>
          <div className="absolute top-6 left-8 right-8 flex items-center">
            <img
              src={SearchIcon}
              alt="Search"
              className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5"
            />
            <input
              id="address-search"
              type="text"
              placeholder="Search address"
              className="w-full pl-10 p-2 focus:outline-none rounded-md border border-[#D0D5DD] shadow-md placeholder-[#D0D5DD]"
              ref={searchBoxRef}
            />
          </div>
          <div className="absolute bottom-4 right-4 flex items-center space-x-2">
            <button
              onClick={handleZoomIn}
              className="bg-white p-2 w-8 h-8 rounded shadow-md"
            >
              +
            </button>
            <button
              onClick={handleZoomOut}
              className="bg-white p-2 w-8 h-8 rounded shadow-md"
            >
              -
            </button>
            <button
              onClick={handleCurrentLocation}
              className="bg-white p-2 w-36 h-8 rounded shadow-md flex items-center whitespace-pre font-plus-jakarta-sans text-sm"
            >
              <img
                src={LocationIcon}
                alt="Current Location"
                className="w-5 h-5 mr-2"
              />
              Current location
            </button>
          </div>
        </div>
        {isAddressSelected && (
          <div className=" bg-white p-8 rounded-lg shadow-md border border-[#D0D5DD]">
            <form className="flex flex-col gap-4">
              <div className="mb-4">
                <label
                  htmlFor="apartment"
                  className="block text-sm font-medium text-gray-700"
                >
                  Apartment / Villa*
                </label>
                <input
                  type="text"
                  id="apartment"
                  className="mt-1 block w-full focus:outline-none rounded-md h-10 border border-[#D0D5DD] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm placeholder-[#667085] pl-2"
                  placeholder="eg-SH-17"
                  value={apartment}
                  onChange={(e) => setApartment(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  htmlFor="address"
                  className="block text-sm font-medium text-gray-700"
                >
                  Your Address*
                </label>
                <input
                  type="text"
                  id="address"
                  className="mt-1 block w-full focus:outline-none rounded-md h-10 border border-[#D0D5DD] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm placeholder-[#667085] pl-2"
                  placeholder="Al Shamkhah – Abu Dhabi"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  required
                />
              </div>
              <div className="mb-2">
                <label
                  htmlFor="additional-address"
                  className="block text-sm font-medium text-gray-700"
                >
                  Additional Address
                </label>
                <input
                  type="text"
                  id="additional-address"
                  className="mt-1 block w-full rounded-md focus:outline-none h-10 border border-[#D0D5DD] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm placeholder-[#667085] pl-2"
                  placeholder="Enter your address here"
                  value={additionalAddress}
                  onChange={handleAdditionalAddressChange}
                />
                {geoFenceError && (
                  <p className="text-red-600 mt-2">{geoFenceError}</p>
                )}{" "}
                {/* Warning message */}
              </div>
              <h2 className="text-base font-bold text-[#344054]">
                Additional Information
              </h2>
              <div className="flex space-x-4 mb-4">
                <div className="flex-1">
                  <label
                    htmlFor="full-name"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Full Name*
                  </label>
                  <input
                    type="text"
                    id="full-name"
                    className="mt-1 block rounded-md focus:outline-none h-10 border border-[#D0D5DD] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm placeholder-[#667085] pl-2"
                    placeholder="Varun Sunara"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    required
                  />
                </div>
                <div className="flex-1">
                  <label
                    htmlFor="mobile-number"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Mobile number*
                  </label>
                  <input
                    type="text"
                    id="mobile-number"
                    className="mt-1 block w-full rounded-md focus:outline-none h-10 border border-[#D0D5DD] shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm placeholder-[#667085] pl-2"
                    placeholder="eg- 9715XXXXXXXX"
                    value={mobileNumber}
                    onChange={(e) => {
                      // Only update the state if the new value has at most 12 digits and is numeric
                      const newValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                      if (newValue.length <= 12) {
                        setMobileNumber(newValue);
                      }
                    }}
                    required
                    maxLength={12} // Limit the input length to 12 characters
                  />
                </div>
              </div>
              {/* <ReCAPTCHA
             sitekey=""
              onChange={handleCaptchaVerify}
            /> */}
              <button
                disabled={
                  !apartment ||
                  !address ||
                  !fullName ||
                  !isValidMobileNumber(mobileNumber) ||
                  mainAddressCountry !== additionalAddressCountry // Disable if countries don't match
                }
                type="submit"
                className="w-full px-6 py-3 bg-yellow-500 hover:bg-yellow-500 hover:bg-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold rounded-md shadow-sm"
                onClick={handleContinue}
              >
                Confirm to continue
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default Address;